export default __webpack_public_path__ + "static/media/apple-touch-icon-152x152.7b16a31e.png";